export default "__VITE_ASSET__D_39ulmv__"